 
/**
 * S24 · Templates — library of form templates. For now it's a static
 * list backed by `lib/templates.ts`; later this becomes a fetched +
 * cached resource when the backend lands.
 */
import { createFileRoute, Link } from '@tanstack/react-router';
import {
  Chip,
  GestureBar,
  I,
  Ico,
  ScreenFrame,
  StatusBar,
  T,
} from '@/components/primitives';
import { listTemplates } from '@kapture/domain';

export const Route = createFileRoute('/templates')({
  component: TemplatesPage,
  staticData: { mobile: true },
});

function TemplatesPage() {
  const templates = listTemplates();
  const recent = templates.slice(0, 3);

  return (
    <ScreenFrame tone="light">
      <StatusBar />
      <div
        style={{
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          borderBottom: `1px solid ${T.stroke}`,
        }}
      >
        <Link
          to="/"
          aria-label="Back"
          style={{ color: T.text, display: 'flex', textDecoration: 'none' }}
        >
          <Ico d={I.back} size={20} />
        </Link>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 15,
              fontWeight: 700,
              fontFamily: T.font,
              letterSpacing: '-0.01em',
            }}
          >
            Templates
          </div>
          <div style={{ fontSize: 11, color: T.textMute, fontFamily: T.font }}>
            {templates.length} available · tap to preview
          </div>
        </div>
        <div style={{ width: 20 }} />
      </div>

      <div style={{ padding: '14px 16px 6px' }}>
        <div
          style={{
            fontSize: 10,
            color: T.textMute,
            fontFamily: T.mono,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            marginBottom: 10,
          }}
        >
          Recently used
        </div>
        <div
          style={{
            display: 'flex',
            gap: 10,
            overflowX: 'auto',
            paddingBottom: 6,
          }}
        >
          {recent.map((t, i) => (
            <div
              key={t.id}
              style={{
                flexShrink: 0,
                width: 180,
                padding: 14,
                borderRadius: 14,
                background: i === 0 ? T.brand : T.surface,
                color: i === 0 ? '#fff' : T.text,
                border: i === 0 ? `1px solid ${T.brand}` : `1px solid ${T.stroke}`,
                boxShadow: i === 0 ? '0 6px 20px rgba(255,90,31,0.25)' : T.sh,
              }}
            >
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  background: i === 0 ? 'rgba(255,255,255,0.18)' : T.surface2,
                  color: i === 0 ? '#fff' : T.textDim,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 10,
                }}
              >
                <Ico d={I.file} size={15} />
              </div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  fontFamily: T.font,
                  letterSpacing: '-0.01em',
                  lineHeight: 1.3,
                }}
              >
                {t.name}
              </div>
              <div
                style={{
                  marginTop: 4,
                  fontSize: 11,
                  fontFamily: T.mono,
                  opacity: i === 0 ? 0.85 : 0.7,
                }}
              >
                v{t.version} · {t.fields.length} fields · {t.sections.length} sections
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: '14px 16px 6px' }}>
        <div
          style={{
            fontSize: 10,
            color: T.textMute,
            fontFamily: T.mono,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            marginBottom: 10,
          }}
        >
          All templates
        </div>
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: '0 16px 16px' }}>
        {templates.map((t) => (
          <div
            key={t.id}
            style={{
              padding: 12,
              borderRadius: 12,
              background: T.surface,
              border: `1px solid ${T.stroke}`,
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              marginBottom: 8,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: T.surface2,
                color: T.textDim,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Ico d={I.file} size={18} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  fontFamily: T.font,
                  letterSpacing: '-0.01em',
                }}
              >
                {t.name}
              </div>
              <div style={{ fontSize: 11, color: T.textMute, fontFamily: T.mono }}>
                v{t.version} · {t.fields.length} fields · used {t.usageCount}×
              </div>
            </div>
            <Chip tone="neutral" size="sm">
              Preview
            </Chip>
          </div>
        ))}
      </div>
      <GestureBar />
    </ScreenFrame>
  );
}
